// extracted by mini-css-extract-plugin
module.exports = {"footer":"ArticleDetailFooterItemDay_footer__dDPuZ","copy":"ArticleDetailFooterItemDay_copy__kLrqG"};